import { createElement } from 'react'
import { attributesToProps, domToReact, Element, type DOMNode, type HTMLReactParserOptions } from 'html-react-parser'

export const getPropsWithoutInlineStyle = <T>(attribs: Record<string, string>) => {
  const props = attributesToProps(attribs) as T & { style?: unknown }
  delete props.style

  return props as T
}

export const renderElementWithoutInlineStyle = (domNode: Element, parseOptions: HTMLReactParserOptions) => {
  const children = domNode.children.length ? domToReact(domNode.children as DOMNode[], parseOptions) : undefined

  return createElement(domNode.name, getPropsWithoutInlineStyle(domNode.attribs), children)
}

export const htmlWithoutInlineStyleParseOptions: HTMLReactParserOptions = {
  replace: domNode => {
    if (!(domNode instanceof Element)) return

    return renderElementWithoutInlineStyle(domNode, htmlWithoutInlineStyleParseOptions)
  },
}
